import fr from 'facet-rest';
import { metaOverrideSet as DefaultStepMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultStep';
import Image from 'Context/AnnouncementContext/Dialog/DialogContent/Image';
import WizardFooterText from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/WizardFooterText';

export default fr.metaOverride({ base: DefaultStepMetaOverrideSet })
  .nameOverride('imageUrl', {
    _component: () => Image,
  }, { ordinal: 200 })
  .nameOverride('footer', {
    _component: () => WizardFooterText,
  }, { ordinal: 200 });
